import React from 'react'

const StepIndicator = ({ currentStep }) => {
  const steps = [
    { id: 'select-event', label: 'Select Event', number: 1 },
    { id: 'upload-photo', label: 'Upload Photo', number: 2 }
  ]

  return (
    <div className="mb-8">
      <div className="flex items-center justify-center space-x-4">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className={`flex items-center ${
              currentStep === step.id
                ? 'text-purple-400'
                : steps.findIndex(s => s.id === currentStep) > index
                  ? 'text-green-400'
                  : 'text-gray-400'
            }`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-2 ${
                currentStep === step.id
                  ? 'bg-purple-500 text-white'
                  : steps.findIndex(s => s.id === currentStep) > index
                    ? 'bg-green-500 text-white'
                    : 'bg-white/20'
              }`}>
                {steps.findIndex(s => s.id === currentStep) > index ? '✓' : step.number}
              </div>
              {step.label}
            </div>
            {index < steps.length - 1 && (
              <div className="w-16 h-0.5 bg-white/20"></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default StepIndicator